import React, { useEffect, useState } from "react";
import {
  Button,
  CopyToClipboard,
  LogoLoader,
  showToast,
  SmartTooltip,
  TableAdv,
} from "../../../../../components";
import { mapTableRows } from "../../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../../hooks";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import { fetchAllProspects } from "../../../../../redux/slices/accountDetails/accountDetailsAPi";
import { formatWords2 } from "../../../../../utils/stringUtils";

const PrimaryContact = ({companyId}) => {
  const dispatch = useDispatch();
  const [prospects, setProspects] = useState([]);
  const [loading, setLoading] = useState(false);
  const { value } = useSelector((state) => state?.totalCount);
  const { page, limit, setPage, handleLimitChange } = usePagination(
        10,
        (newPage, newLimit) => {}
      );
  const totalCount = value?.primaryContacts?.data || 0;
  const whatsappIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="14"
      height="14"
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label="WhatsApp"
    >
      <title>WhatsApp</title>

      <path
        fill="#25D366"
        d="M20.52 3.48A11.94 11.94 0 0 0 12 0C5.37 0 .02 5.35.02 12c0 2.11.55 4.08 1.6 5.83L0 24l6.42-1.68A11.94 11.94 0 0 0 12 24c6.63 0 12-5.35 12-12 0-3.2-1.25-6.2-3.48-8.32z"
      />

      <path
        fill="#FFFFFF"
        d="M17.56 14.01c-.3-.15-1.76-.86-2.03-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.95 1.15-.17.2-.34.22-.64.07-.3-.15-1.27-.47-2.42-1.48-.9-.8-1.51-1.78-1.69-2.08-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.29.3-.48.1-.2.05-.37-.03-.52-.08-.15-.67-1.6-.92-2.19-.24-.57-.48-.49-.66-.5l-.56-.01c-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.48 1.06 2.88 1.21 3.08c.15.2 2.09 3.2 5.07 4.48 2.98 1.29 2.98.86 3.52.81.54-.05 1.76-.72 2.01-1.41.25-.69.25-1.28.17-1.41-.08-.13-.27-.2-.57-.35z"
      />
    </svg>
  );

  const columns = [
    {
      key: "name",
      label: "Name",
    },
    {
      key: "emailId",
      label: "Email ID",
      render: (row) => (
        <div className="flex items-center">
          <CopyToClipboard content={row?.emailId} title={row?.emailId} />
          {row?.emailId}
        </div>
      ),
    },
    {
      key: "phoneNumber",
      label: "Phone Number",
      render: (row) => (
        <div className="flex items-center">
          <SmartTooltip description={"Phone"} noicon>
            <Button
              type="icon"
              icon={"phone_in_talk"}
              variant="text"
              color="black"
              size="sm"
            />
          </SmartTooltip>

          {row?.phoneNumber}
          <SmartTooltip description={"text"} noicon>
            <Button
              type="icon"
              icon={"chat"}
              variant="text"
              color="black"
              size="sm"
            />
          </SmartTooltip>
          <SmartTooltip description={"Whatsapp"} noicon>
            <Button
              type="icon"
              variant="text"
              color="black"
              size="sm"
              icon={whatsappIcon}
            />
          </SmartTooltip>
        </div>
      ),
    },
    {
      key: "jobTitle",
      label: "Job Title",
    },
    {
      key: "location",
      label: "Location",
    },
  ];

  // const rows = Array.from({ length: 5 }, (_, i) => ({
  //   name: "Ershad",
  //   emailId: "vamshi@Tektree.inc",
  //   phoneNumber: "998998888",
  //   jobTitle: "Frontend Developer",
  //   location: "Dallas",
  // }));
  const rows = prospects.map((item) => ({

    name: `${formatWords2(item?.firstName || "")} ${formatWords2(item?.lastName || "")}`.trim() || "-",
    // emailId: item?.email || "-",
    emailId: item?.email?.email || item?.email || "-",
    phoneNumber: item?.mobile
      ? `${item?.mobile?.code || ""} ${item?.mobile?.number || ""}`
      : "-",
    // location: item.location
    //   ? `${item.location.city || ""}, ${item.location.state || ""}, ${item.location.country || ""}`
    //   : "-",
    location: item?.location
      ? [item?.location?.city, item?.location?.state, item?.location?.country]
          .filter(Boolean)  
          .join(", ")
      : "-",
  }));

  const mappedRows = mapTableRows(rows, columns);

  useEffect(() => {
      const loadProspects = async () => {
        if(!companyId) {
          showToast("Company ID is missing","error");
          return;
        }
        try {
          setLoading(true);
          const response = await fetchAllProspects({
            coll: "Prospect",
            fil: {companyId:{"type": "NONE", "value": companyId},inpersonResponseStatus:{"type": "NONE", "value": 2}},
            pg: page,
            lim: limit,
            ret: "uiid firstName lastName email mobile location",
          });
  
          if (response?.data?.data?.length) {
            setProspects(response.data.data);
          } else {
            setProspects([]);
          }
        } catch (error) {
          console.error("Error fetching prospects:", error);
          setProspects([]);
        } finally {
          setLoading(false);
        }
      };
      dispatch(
        totalCountStart({
          collection: "prospects",
          coll: "Prospect",
          tname: "primaryContacts",
          filters: {companyId:{"type": "NONE", "value": companyId},inpersonResponseStatus:{"type": "NONE", "value": 2}},
          app: "ats",
        })
      );
  
    loadProspects();
  }, [dispatch, limit, page,companyId]);

  if (loading) {
      return (
        <div className="flex items-center justify-center h-64">
          <LogoLoader />
        </div>
      );
    }

  return (
    <div>
      <TableAdv
        columns={columns}
        showSlNo
        showCheckbox
        rows={mappedRows}
        serverPagination={true}
        totalCount={totalCount}
        page={page}
        limit={limit}
        tableId={"accountdetails_primarycontacts"}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        toolbarRight={{
          search: true,
          filter: false,
          download: false,
          add: [
            {
              component: <Button title="Send Mail" size="sm" />,
            },
          ],
        }}
      />
    </div>
  );
};

export default PrimaryContact;
